<template>
  <div class="preview">
    <loader ref="loader" />
    <!-- <div class="preview__top">
      <div class="preview__title">
         {{ $t('preview.title', {partner: title}) }}
      </div> -->
    <!-- <MultiDropdown class="w-40"/>
    </div> -->
    <div class="mb-10">
      <div v-b-toggle.collapse class="toggle-collapse">
        <div class="order-details">
          <span class="order-details__text">
            {{ $t('unauth-payment.order-details') }}
          </span>
          <span class="order-details__items-total">
            ({{ cart && cart.cart
              && Object.values(cart.cart).length}} {{$t('unauth-payment.items')}})
          </span>
        </div>
        <div class="d-flex flex-column">
          <div class="total">
            <span class="total__text">
              Total
              <span class="amount ml-1">
                {{ cart.amount }} {{ cart.currency }}
              </span>
            </span>
            <img src="@/assets/img/arrow.svg" alt="arrow" :class="isExpanded ? 'rotate' : ''">
          </div>
          <div v-if="isSubscription" class="subscription-text"> Subscription Included </div>
        </div>
      </div>
      <b-collapse
        id="collapse"
        class="collapse-content-wrapper"
        v-model:open="isExpanded"
        v-for="(item, i) in cart.cart"
        :key="i"
      >
        <div class="collapse-content-wrapper__inner">
          <span> {{ item.name }} </span>
          <span> {{ item.price }} {{ cart.currency }}
            <span class="freq" v-if="item.isSubscription">/{{item.frequency}}</span></span>
        </div>
      </b-collapse>
    </div>
    <PaymentOptionsCard
      :allPaymentTabs="allPaymentTabs"
      :walletOptions="allCoins"
      :qrData="{}"
      :currencies="currencies"
      :anyWalletError="''"
      :anyWalletCoin="{}"
      :convertedCart="convertedCart"
      :displayCurrency="displayCurrency"
      @tab-changed="tabChanged"
      :coin="{}"
      :coinsOptions="coinsOptions"
      :stocksOptions="allPaymentTabs['crypto']"
      :stock="{}"
      :isPreview="true"
    />
    <div class="how-to-proceed">
      {{ $t('preview.how-to-proceed')}}
    </div>
    <div class="buttons">
      <CustomButton
        :name="$t('preview.sign_in')"
        className="sign-in button-default"
        @handle-click="goToSignin"
      />
      <CustomButton
        :name="$t('preview.sign-up')"
        className="sign-up button-default-outline"
        @handle-click="goToSignup"
      />
    </div>
    <div class="or-circle">
      <span>{{ $t('preview.or')}}</span>
    </div>
    <hr class="or-hr" />
    <div class="proceed-guest">
      <CustomButton
        :name="$t('preview.proceed-btn')"
        className="w-100 button-default-outline p-12"
        @handle-click="proceedWithGuestUser"
      />
    </div>
    <!-- eslint-disable-next-line-->
    <component is="style" scoped>
      :root {
      --button-default-background-color:{{ defaultButtonBackgroundColor }};
      --button-default-text-color:{{ defaultButtonTextColor }};
      --button-default-hover-background-color:{{ defaultButtonHoverBackgroundColor }};
      --button-default-hover-text-color:{{ defaultButtonHoverTextColor }};
      --button-default-outline-background-color:{{ defaultOutlineButtonBackgroundColor }};
      --button-default-outline-text-color:{{ defaultOutlineButtonTextColor }};
      }
    </component>
  </div>
</template>

<script>

// import MultiDropdown from '@/components/MultiDropdown.vue';
import { mapGetters } from 'vuex';
import { BCollapse } from 'bootstrap-vue';
import PaymentOptionsCard from '@/components/paymentOptionCard.vue';

import {
  GET_CURRENCIES,
  GET_MARKET_INFO,
  ADD_COINBASE,
  SET_TAB,
  // GET_EXCHANGES,
  // GET_PAYMENT_OPTIONS,
} from '@/store/modules/user/consts';
import CustomButton from './customButton.vue';
import helper, { isUSD } from '../utils/helper';
import { COINBASE, CRYPTO, DEFAULT_CURRENCY } from '../utils/stringconsts';

export default {
  name: 'Preview',
  components: {
    CustomButton,
    PaymentOptionsCard,
    // MultiDropdown,
    BCollapse,
  },
  data() {
    return {
      convertedCart: {},
      selectedValue: this.$DbStorage.getItem('lang') ? this.$DbStorage.getItem('lang') : 'ENG',
      cryptoWallet: [],
      isExpanded: false,
    };
  },
  watch: {
    async cartConversionData(newVal) {
      let conversionRate = 1;
      let usdEquivalentRate = 1;
      if (newVal.settings?.displayCurrency !== undefined
      && newVal.cart) {
        // some clients do not pass cart currency
        // eslint-disable-next-line no-param-reassign
        newVal.cart.currency = newVal.cart?.currency !== undefined ? newVal.cart?.currency : 'USD';
        // Perform conversion if the currency are different
        if (newVal.settings?.displayCurrency.toUpperCase()
        !== newVal.cart?.currency.toUpperCase()) {
          conversionRate = await this.getCurrConverRate(newVal.cart?.currency, newVal.settings?.displayCurrency);
          usdEquivalentRate = conversionRate;
        }
        // need USD for conversion to crypto (Base currency)
        if (!isUSD(newVal.cart?.currency)
        && !isUSD(newVal.settings?.displayCurrency)) {
          usdEquivalentRate = await this.getCurrConverRate(newVal.cart?.currency, DEFAULT_CURRENCY);
        } else if (isUSD(newVal.cart?.currency)) {
          usdEquivalentRate = 1;
        }
        this.convertedCart = newVal.cart;
        this.convertedCart.usdEquivalentRate = usdEquivalentRate;
        this.convertedCart.conversionRate = conversionRate;
        this.convertedCart.displayCurrency = newVal.settings?.displayCurrency.toUpperCase();
      }
    },
    async cart() {
      if (this.cart && Object.values(this.cart).length) {
        window.EventBus.emit('DELETE_INFO_MESSAGE', { message: 'waiting cart...' });
        await this.getData();
        this.$refs.loader.end();
      }
    },
    async auth(newValue) {
      if (newValue) {
        this.$router.go(this.$router.currentRoute);
      }
    },
  },
  mounted() {
    window.EventBus.emit('is-preview', true);
    setTimeout(() => {
      this.$refs.loader.end();
    }, 2500);
    this.$nextTick(async () => {
      // if coinbase success
      if (this.$route.query.code) {
        await this.$store.dispatch(`user/${ADD_COINBASE}`, this.$route.query.code);
        this.popup = window.open('', 'exchange_connect', `width=585, height=800, top=${(window.screen.height - 800) / 2}, left=${(window.screen.width - 585) / 2}, _blank`);
        if (this.popup) {
          this.popup.focus();
          this.popup.close();
        }

        this.popup = null;
      }
      if (this.cart && Object.values(this.cart).length) {
        await this.getData();
      } else {
        window.EventBus.emit('ADD_INFO_MESSAGE', { message: 'waiting cart...' });
      }
    });
  },
  computed: {
    ...mapGetters({
      cart: 'user/cart',
      conversionInfo: '/user/conversionInfo',
      stocks: 'user/stocks',
      userInfo: 'user/userInfo',
      settings: 'user/settings',
      currencies: 'user/currencies',
      displayCurrency: 'user/displayCurrency',
      marketInfo: 'user/marketInfo',
      allStocks: 'user/allStocks',
      paymentOptions: 'user/paymentOptions',
      paymentWallet: 'user/getPaymentWallet',
      auth: 'auth/isAuth',
    }),
    title() {
      if (this.marketInfo
        && this.marketInfo.whiteLabel
        && this.marketInfo.whiteLabel.colorSchema
        && this.marketInfo.whiteLabel.colorSchema.partnerLabel
      ) {
        return this.marketInfo.whiteLabel.colorSchema.partnerLabel;
      }

      return 'Rocketfuel';
    },
    allPaymentTabs() {
      const resp = this.getPaymentOptions(this.stocks, this.settings, this.paymentOptions, this.cart);
      if (!resp) {
        return {};
      }
      resp.default = helper.getLowerCase(CRYPTO);
      delete resp.legacyStockFormat;
      return resp;
    },
    cartConversionData() {
      return { cart: this.cart, settings: this.settings };
    },
    stocksOptions() {
      const resp = this.getPaymentOptions(this.stocks, this.settings, this.paymentOptions, this.cart);
      return resp.legacyStockFormat;
    },
    // All coins to pay with any coin
    allCoins() {
      const coins = this.getAllCoins(this.currencies, this.paymentOptions);
      return coins;
    },
    coinsOptions() {
      // coinbase options
      const coins = this.getCoinsOptions(
        this.stocks,
        helper.getLowerCase(COINBASE),
        this.settings,
      );
      return coins;
    },
    defaultButtonBackgroundColor() {
      if (
        this.marketInfo
        && this.marketInfo.whiteLabel
        && this.marketInfo.whiteLabel.colorSchema
        && this.marketInfo.whiteLabel.colorSchema.colors
        && this.marketInfo.whiteLabel.colorSchema.colors.some((el) => el.name === 'Button')
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find((el) => el.name === 'Button');
        const child = section.children.find((el) => el.name === 'Default');
        const property = child.properties.find((el) => el.name === 'Background Color');
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return '#f0833c';
    },
    defaultButtonTextColor() {
      if (
        this.marketInfo
        && this.marketInfo.whiteLabel
        && this.marketInfo.whiteLabel.colorSchema
        && this.marketInfo.whiteLabel.colorSchema.colors
        && this.marketInfo.whiteLabel.colorSchema.colors.some((el) => el.name === 'Button')
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find((el) => el.name === 'Button');
        const child = section.children.find((el) => el.name === 'Default');
        const property = child.properties.find((el) => el.name === 'Text Color');
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return '#ffffff';
    },
    defaultButtonHoverBackgroundColor() {
      if (
        this.marketInfo
        && this.marketInfo.whiteLabel
        && this.marketInfo.whiteLabel.colorSchema
        && this.marketInfo.whiteLabel.colorSchema.colors
        && this.marketInfo.whiteLabel.colorSchema.colors.some((el) => el.name === 'Button')
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find((el) => el.name === 'Button');
        const child = section.children.find((el) => el.name === 'Default');
        const property = child.properties.find((el) => el.name === 'Background Color on hover');
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return '#0d102a';
    },
    defaultButtonHoverTextColor() {
      if (
        this.marketInfo
        && this.marketInfo.whiteLabel
        && this.marketInfo.whiteLabel.colorSchema
        && this.marketInfo.whiteLabel.colorSchema.colors
        && this.marketInfo.whiteLabel.colorSchema.colors.some((el) => el.name === 'Button')
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find((el) => el.name === 'Button');
        const child = section.children.find((el) => el.name === 'Default');
        const property = child.properties.find((el) => el.name === 'Text Color On hover');
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return '#ffffff';
    },
    defaultOutlineButtonBackgroundColor() {
      if (
        this.marketInfo
        && this.marketInfo.whiteLabel
        && this.marketInfo.whiteLabel.colorSchema
        && this.marketInfo.whiteLabel.colorSchema.colors
        && this.marketInfo.whiteLabel.colorSchema.colors.some((el) => el.name === 'Button')
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find((el) => el.name === 'Button');
        const child = section.children.find((el) => el.name === 'Outline');
        const property = child.properties.find((el) => el.name === 'Background Color');
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return '#ffffff';
    },
    defaultOutlineButtonTextColor() {
      if (
        this.marketInfo
        && this.marketInfo.whiteLabel
        && this.marketInfo.whiteLabel.colorSchema
        && this.marketInfo.whiteLabel.colorSchema.colors
        && this.marketInfo.whiteLabel.colorSchema.colors.some((el) => el.name === 'Button')
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find((el) => el.name === 'Button');
        const child = section.children.find((el) => el.name === 'Outline');
        const property = child.properties.find((el) => el.name === 'Text Color');
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return '#5e72e4';
    },
    isSubscription() {
      if (this.cart.cart && this.cart.cart && this.cart.cart.length) {
        const subs = this.cart.cart.some((el) => el.isSubscription);
        return subs;
      }
      return false;
    },
  },
  methods: {
    goToSignin() {
      this.$store.dispatch(`user/${SET_TAB}`, '');
      this.$router.push({
        name: 'Sign in',
      });
    },
    goToSignup() {
      this.$store.dispatch(`user/${SET_TAB}`, '');
      this.$router.push({
        name: 'SignUp',
      });
    },
    proceedWithGuestUser() {
      this.$store.dispatch(`user/${SET_TAB}`, '');
      this.$router.push({
        name: 'VerifyGuest',
      });
    },
    async getData() {
      const request = [
        this.$store.dispatch(`user/${GET_CURRENCIES}`, {
          merchantId: this.cart.merchant_id,
        }),
        // this.$store.dispatch(`user/${GET_EXCHANGES}`),
        this.$store.dispatch(`user/${GET_MARKET_INFO}`, { merchantId: this.cart.merchant_id }),
        // this.$store.dispatch(`user/${GET_PAYMENT_OPTIONS}`, this.cart.merchant_id),
      ];
      await Promise.all(request);
      this.setDisplayCurrency();
      this.cryptoWallet = this.$store.state.user.paymentOptions;
    },
    selectLang(event) {
      this.selectedValue = event.target.innerText;
      this.$i18n.locale = this.selectedValue;
      this.$DbStorage.setItem('lang', this.selectedValue);
    },
  },
};
</script>

<style lang="scss" scoped>
  .mb-10 {
    margin-bottom: 10px;
  }
.preview {
  padding: 80px 20px 20px;
  display: grid;
  gap: 15px;
  .toggle-collapse {
    border: 1px solid #D7D8D6;
    padding: 8px;
    border-radius: 5px;
    background-color: #ededee;
    display: flex;
    align-items: center;
    font-size: 14px;
    outline: none;
    .order-details {
      width: 60%;
      &__text {
        font-weight: 500;
      }
      &__items-total {
        font-size: 13px;
        font-weight: 500;
        color: #6E728B;
      }
    }
    .subscription-text {
    color: #5559FE;
    font-size: 10px;
    white-space: nowrap;
    font-weight: 700;
    }
    .total {
      display: flex;
      justify-content: space-around;
      &__text {
        font-weight: 500;
        color: #6E728B;
        .amount {
            float: right;
            font-weight: bold;
            font-size: 18px;
            line-height: 18px;
            white-space: nowrap;
            color: #000;
        }
      }
      img {
        transition: transform 0.6s;
      }
      .rotate {
        transform: rotate(180deg);
      }
    }
  }
  .collapse-content-wrapper {
    &__inner {
      display: flex;
      justify-content: space-between;
      padding: 8px;
      border: 1px solid #D7D8D6;
      border-radius: 5px;
      font-size: 14px;
      font-weight: 500;
      border-top: none;
    }
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
  }

  &__title {
    font-size: 20px;
    line-height: 23px;
  }

  &__sign-in {
    font-size: 14px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    line-height: 23px;
  }

  &__link {
    text-decoration: underline;
    color: $blue500;
    &:hover {
      text-decoration: none;
    }
  }
  .how-to-proceed {
    text-align: center;
    font-size: 16px;
    color: #56566f;
  }
  .buttons {
    .sign-in {
      width: 48% !important;
      padding: 10px;
      margin-right: 3px;
    }
    .sign-up {
      width: 48%;
      padding: 10px;
      margin-left: 3px;
    }
  }
  .or-circle {
    margin: 20px auto 0;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    display: flex;
    background-color: #d7d8d7;
    justify-content: center;
    align-items: center;
    span {
      color: #57576e;
      font-size: 14px;
    }
  }
  .or-hr {
    width: 100%;
    margin-top: -32px;
    z-index: -1;
    border-top: 1px solid #d7d8d7;
    margin-bottom: 0;
  }
  .terms-conditions {
    margin-top: -10px;
    input {
      vertical-align: middle;
      margin-right: 5px;
    }
    span {
      font-size: 12px;
      color: #898ca1;
      .text-orange {
        color: #f0833c;
        font-weight: 500;
      }
    }
  }
}
.btn-lang{
  float:right;
}
.tip {
  display: flex;
  align-items: center;

  &__icon {
    width: 18px;
    min-width: 18px;
    height: 18px;
    cursor: pointer;
    margin-right: 11px;
    border: 2px solid #1D1D3F;
    padding: 2px;
    border-radius: 50%;
  }
  &__text {
    font-size: 14px;
    font-weight: 500;
    line-height: 23px;
    padding-left: 1px;
  }
}
.cs-dd {
  position: relative;
  height: auto;
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 15px;

  &__btn {
    cursor: pointer;
    background: $gradient-grey;
    border: 1px solid $border;
    width: 100%;
    height: 45px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    outline: none;
    border-radius: 4px;
    &.not-collapsed {
      & .cs-dd__arrow {
        transform: rotate(180deg);
      }
    }
  }

  &__arrow {
    width: 30px;
    min-width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .35s;
  }
}
.cs-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &__title {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__total {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    margin-right: 5px;
  }
}
.freq {
    color: #5559FE;
    font-size: 12px;
    font-weight: 900;
}
</style>
